import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { DetailsService } from '../services/details.service';
import { IInventoryMasterDetail } from '../interfaces';
import { ViewMasterDetailWithImage } from '../models';

@Component({
  selector: 'app-inventory-manager',
  templateUrl: './inventory-manager.component.html',
  styleUrls: ['./inventory-manager.component.css']
})
export class InventoryManagerComponent implements OnInit {
	
	isAuthenticated: boolean = false;
  masterRecords: IInventoryMasterDetail[] = [];
  groupId: number = 0;
  // selections: any[] = [];
  message: string = '';

  constructor(private detailsService: DetailsService, private router: Router) { }

  ngOnInit() {
    if(sessionStorage.getItem("token")){
          let obj = JSON.parse(sessionStorage.getItem("token"));
          if(obj && obj.Token != ""){
            this.isAuthenticated = true;
          }
      }
      else {
        this.router.navigate(['/login']);
      }

      let group = JSON.parse(sessionStorage.getItem("groupId"));
      this.groupId = 0;
      if(group && group.GroupId != 0){
        this.groupId = group.GroupId;
        this.detailsService.getMasterDetailRecords(this.groupId).subscribe(
          records => {
          this.masterRecords = records;
        });  
      }
  }

  openInventoryDetails(id: number){
    this.router.navigate(['/view-inventory/', id.toString()]);
  }

  editInventoryDetails(id: number){
    this.router.navigate(['/edit-inventory/', id.toString()]);
  }

  addInventoryDetails(id: number){
    this.router.navigate(['/add-details/', id.toString()]);
  }

  deleteRecord(id)
  {
    let record = this.masterRecords.find(r => {return r.Id == id});
    let confMessage = ''

    confMessage = "Are you sure you want to delete " + record.AnimalName +"-"+ record.AnimalID;
    if(confirm(confMessage))
    {
      let masterToDelete = new ViewMasterDetailWithImage();
      masterToDelete.masterDetail = record;
      this.detailsService.deleteMasterDetailRecord(masterToDelete).subscribe(
        resp => {
          this.detailsService.getMasterDetailRecords(this.groupId).subscribe(
          records => {
          this.masterRecords = records;
          this.message = 'Record successfully deleted';
        }); 
      });
      
    }
  }

  // modifySelections(recordId)
  // {
  //   if(this.selections.length ==0)
  //   {
  //     this.selections.push(recordId);
  //   }
  //   else{
  //     let exists = this.selections.find(s => { return s == recordId});
  //     if(exists){
  //       let index = this.selections.indexOf(exists);
  //       if (index !== -1) {
  //           this.selections.splice(index, 1);
  //       }
  //     }
  //     else{
  //        this.selections.push(recordId);   
  //     }
  //   }
  // }

  // printSelectedCards()
  // {
  //   console.log(this.selections);
  // }

}



// WEBPACK FOOTER //
// ./src/app/inventory-manager/inventory-manager.component.ts